import Axios from 'axios';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';


const getDefaultState = () => {
  return {
    token: '',
    user: {},
    selectedPool: null
  };
};

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: getDefaultState(),
  getters: {
    isLoggedIn: state => {
      return state.token;
    },
    getUser: state => {
      return state.user;
    },
    getSelectedPool: state => {
      return state.selectedPool;
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_SELECTED_POOL: (state, pool) => {
      state.selectedPool = pool;
    },
    RESET: state => {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    // eslint-disable-next-line
    login: ({ commit, dispatch }, { token, user }) => {
      commit('SET_TOKEN', token);
      commit('SET_USER', user);

      // set auth header
      Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    logout: ({ commit }) => {
      commit('RESET', '');
    }
  }
});
